window.PIB_DEFAULT_DATA = {
  version: 3,
  socialLinks: [
    { id: "social-facebook", title: "Facebook", url: "https://www.facebook.com/" },
    { id: "social-tiktok", title: "TikTok", url: "https://www.tiktok.com/" },
    { id: "social-instagram", title: "Instagram", url: "https://www.instagram.com/" },
    { id: "social-shopee", title: "Shopee", url: "https://shopee.com.my/" }
  ],
  teacherModules: [
    { id: "erph-1", title: "e-RPH Sekolah Rendah", description: "Rancangan pengajaran harian yang tersusun dan mudah dicapai.", url: "https://example.com/e-rph", icon: "📋" }
  ],
  years: [
    { id: "tahun-1", title: "Tahun 1", subjects: [
      { id: "matematik", title: "Matematik", icon: "➗", cover: "", modules: [
          { id: "jawapan", title: "Jawapan", icon: "✓", url: "https://example.com/jawapan" },
          { id: "modul-ekstra", title: "Modul Ekstra", icon: "+", url: "https://example.com/modul-ekstra" },
          { id: "latihan", title: "Latihan", icon: "✎", url: "https://example.com/latihan" },
          { id: "nota", title: "Nota", icon: "▤", url: "https://example.com/nota" }
        ], books: [
        { id: "math-t1-aktiviti", title: "Buku Aktiviti Matematik Tahun 1", description: "Latihan dan bahan pengukuhan Matematik selaras dengan pembelajaran sekolah rendah.", cover: "", modules: [
          { id: "jawapan", title: "Jawapan", icon: "✓", url: "https://example.com/jawapan" },
          { id: "modul-ekstra", title: "Modul Ekstra", icon: "+", url: "https://example.com/modul-ekstra" },
          { id: "latihan", title: "Latihan", icon: "✎", url: "https://example.com/latihan" },
          { id: "nota", title: "Nota", icon: "▤", url: "https://example.com/nota" }
        ]}
      ]},
      { id: "bahasa-melayu", title: "Bahasa Melayu", icon: "Aa", cover: "", modules: [], books: [] },
      { id: "sains", title: "Sains", icon: "⚗", cover: "", modules: [], books: [] }
    ]},
    { id: "tahun-2", title: "Tahun 2", subjects: [] },
    { id: "tahun-3", title: "Tahun 3", subjects: [] },
    { id: "tahun-4", title: "Tahun 4", subjects: [] },
    { id: "tahun-5", title: "Tahun 5", subjects: [] },
    { id: "tahun-6", title: "Tahun 6", subjects: [] }
  ]
};
